import React from 'react';
import { Component } from 'react';
import { Form, Select } from '@tesla/react-context-form';
import { InitialState } from '../../data/initialState';
import { connect } from 'react-redux';
import { linkPlaceholder } from '../../utils/TranslationUtils';

class TimeSelectionBlock extends Component {
    constructor(props) {
        super(props);
        this.elems = {};
        this.state = {
            day: null,
            time: null,
            location: null
        }
        this.setLocation(null);
        this.setData(null);
        this.handleData();
    }

    handleLocationChange(e) {
        if (window.Tesla.country.toUpperCase() == "CN" && e.value == "") {
            this.props.handleChange(e);
            this.props.updateValue("day", null);
            this.props.updateValue("time", null);
            this.setState({
                location: null,
                day: null,
                time: null
            });
        } else {
            document.getElementById("location-msg").innerHTML = "";
            document.getElementById("location").setAttribute('class',"item-container")
            const location = e.value,
                data = this.getData(),
                currLoc = data[location];

            let day = null,
                time = null;

            if (!currLoc.storeDetails.noAppointments) {
                day = Object.keys(currLoc.appointmentTimeSlots.times)[0];
                time = Object.keys(currLoc.appointmentTimeSlots.times[day])[0];
            }

            this.props.handleChange(e);
            this.props.updateValue("day", day);
            this.props.updateValue("time", time);

            this.setState({
                location: location,
                day: null,
                time: null
            });
        }
    }

    handleDayChange(e) {
        const value = e.target.value,
            loc = this.state.location || this.getLocation(),
            data = this.getData(),
            currLoc = data[loc],
            time = Object.keys(currLoc.appointmentTimeSlots.times[value])[0];

        this.props.handleChange(e);
        this.props.updateValue("time", time);
        this.setState({
            day: value,
            time: null
        });
    }

    handleTimeChange(e) {
        this.props.handleChange(e);
        this.setState({
            time: e.target.value
        });
    }

    setData(value) {
        this._data = value;
    }

    getData() {
        return this._data;
    }

    setSortedFinalData(value) {
        this._sortedFinalData = value;
    }

    getSortedFinalData() {
        return this._sortedFinalData;
    }

    setLocation(value) {
        this._location = value;
        this.props.updateValue("location", value);
    }

    getLocation() {
        return this._location;
    }

    setDay(value) {
        this._day = value;
        this.props.updateValue("day", value);
    }

    getDay() {
        return this._day;
    }

    setTime(value) {
        this._time = value;
        this.props.updateValue("time", value);
    }

    getTime() {
        return this._time;
    }

    getSelectOptions(value, name, label, func, options, id) {
        return (
            <div className="tds-form-item">
                <label className="tds-form-item-label" htmlFor={"select-" + name}>{label}</label>
                <div className="tds-select">
                    <select value={value} name={name} className="tds-select-input" id={"select-" + name} onChange={func} autoscript={id}>
                        {
                            Object.keys(options).map( (id, key) => {
                                let formattedVal = ( typeof options[id].timeFormatted !== "undefined" ? options[id].timeFormatted : options[id] );
                                return <option key={key} value={id}>{formattedVal}</option>
                            })
                        }
                    </select>
                    <i className="tds-icon tds-icon-arrow-down tds-select-arrow"></i>
                </div>
            </div>
        )
    }

    handleData() {
        let { data, getModel, getSortedData } = this.props,
            finalData = null,
            locationArray = [],
            availableLocationArray = [];

        const model = getModel();
        const sortedData = getSortedData();

        for (let locations in sortedData) {
            availableLocationArray.push(sortedData[locations].StoreNr);
        }

        if (model != null && data != null) {
            finalData = {};

            for (let i = 0; i < availableLocationArray.length; i++) {
                let location = availableLocationArray[i];
                let currLoc = data[location];

                if (currLoc.availableModels.indexOf(model) > -1) {
                    if (this.getLocation() == null) {
                        this.setLocation(location);
                        const tmpTimes = data[this.getLocation()].appointmentTimeSlots.times;
                        this.setDay(Object.keys(tmpTimes)[0]);
                        this.setTime(Object.keys(tmpTimes[this.getDay()])[0]);
                    }

                    finalData[location] = data[location];
                    locationArray.push(location);
                }

                if (currLoc.storeDetails.noAppointments) {
                    if (this.getLocation() == null) {
                        this.setLocation(location);
                    }
                    finalData[location] = data[location];
                    locationArray.push(location);
                }
            }
        }

        let sortedDataFinal = [];
        for (let selLocation in sortedData) {
            const currLoc = sortedData[selLocation];
            if (locationArray.includes(currLoc.StoreNr)) {
                sortedDataFinal.push(currLoc);
            }
        }

        this.setSortedFinalData(sortedDataFinal);
        this.setData(finalData);
    }

    render() {
        let data = this.getData(),
            dates = null,
            times = null,
            { day, location, time } = this.state,
            currLocation = null,
            currLocationInfo = null,
            values = null,
            showDayAndTime = null;

        if (window.Tesla.country.toUpperCase() == "CN" && location == null && this.getSortedFinalData().length > 1) {
            showDayAndTime = null;
            values = {
                day,
                time
            };
            currLocationInfo = {
                city: "",
                countryCode: "",
                findUsId: "",
                isAssetLite: false,
                mapUrl: "",
                noAppointments: true,
                phoneNumber: "",
                stateProvince: "",
                storeName: "",
                streetAddress: "",
                zipCode: "",
            }
            this.setLocation(null);
        } else {
            if (location == null) {
                location = this.getLocation();
            }

            showDayAndTime = !data[location].storeDetails.noAppointments;

            if (showDayAndTime) {
                if (day == null) {
                    day = Object.keys(data[location].appointmentTimeSlots.times)[0];
                }

                if (time == null) {
                    time = Object.keys(data[location].appointmentTimeSlots.times[day])[0];
                }

                dates = data[location].appointmentTimeSlots.dates;
                times = data[location].appointmentTimeSlots.times[day];
            }

            values = {
                day,
                time
            };
            currLocation = data[location];
            currLocationInfo = currLocation.storeDetails;
        }

        const sortedData = this.getSortedFinalData();
        const tesla = window.tesla || {};
        const timeSelection = (typeof tesla !== "undefined") ? tesla.App.strings['Test_Drive/All'].content.timeSelection : {};

        return (
            <div className='time-content-container-outer'>
                {data != null ?
                    <div className='time-content-container'>
                        <div className='time-data-container'>
                            <Form initialValues={values}>
                                <div id = "location" className={"item-container "}>
                                    <Select name="location" label={timeSelection.location} onChange={this.handleLocationChange.bind(this)} autoscript="edit-location" >
                                        {window.Tesla.country.toUpperCase() == "CN" && sortedData.length > 1 ?
                                            <option value="">请选择门店</option>
                                            : null }
                                        {
                                            Object.keys(sortedData).map( (id, key) =>
                                                <option key={key} value={sortedData[id].StoreNr}>{sortedData[id].storeDetails.storeName}</option>
                                            )
                                        }
                                    </Select>
                                    {showDayAndTime ?
                                        this.getSelectOptions(day, "day", timeSelection.day, this.handleDayChange.bind(this), dates, "edit-preferred-date")
                                        : null }
                                    {showDayAndTime ?
                                        this.getSelectOptions(time, "time", timeSelection.time, this.handleTimeChange.bind(this), times, "edit-preferred-time")
                                        : null }
                                    <p id='location-msg' className="tds-form-item-feedback"></p>
                                </div>
                            </Form>
                            <p className='time-note' dangerouslySetInnerHTML={{__html: linkPlaceholder(
                                    timeSelection.timeNote,
                                    { CONTACT_US: timeSelection.timeNoteLbl },
                                    '/contact',
                                    ['tds-link--primary']
                                )}} />
                        </div>

                        <div className='time-map-container'>
                            <h4>{currLocationInfo.storeName !== "" ? currLocationInfo.storeName : null}</h4>
                            <p className="map-text">
                                {currLocationInfo.streetAddress !== "" ? currLocationInfo.streetAddress : null}<br />{currLocationInfo.city !== "" ? currLocationInfo.city + ",": null} {currLocationInfo.stateProvince !== "" ? currLocationInfo.stateProvince : null} {currLocationInfo.zipCode !== "" ? currLocationInfo.zipCode : null}<br/>
                                {currLocationInfo.phoneNumber !== "" ? currLocationInfo.phoneNumber : null}
                            </p>
                            {currLocationInfo.findUsId !== "" ?
                            <p className="map-text">
                                <a className="driving-directions tds-link--primary" href={"/" + currLocationInfo.findUsId} target="_blank" rel="noopener noreferrer">
                                    {timeSelection.hoursAndDirection}
                                </a>
                            </p>
                            : null }
                            {window.Tesla.country.toUpperCase() == "CN" ? null : <img src={currLocationInfo.mapUrl} className="map-img" alt="map-location" />}
                        </div>
                    </div>
                    : null }
            </div>
        )
    }
}

TimeSelectionBlock.defaultProps = InitialState().timeSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        data: _state.timeSection.data,
        model: _state.timeSection.model
    }
}

const TimeSelection = connect(
    mapStateToProps
)(TimeSelectionBlock)

export default TimeSelection
